import { configureStore } from '@reduxjs/toolkit';
import lookupReducer from './slices/lookupSlice';
import customerReducer from "./slices/customerSlice";
import loginReducer from './slices/loginSlice';
import forgetPasswordReducer from './slices/forgetPasswordSlice';
import priceOfferReducer from './slices/priceOfferSlice';
import notificationTypeReducer from "./slices/notificationTypeSlice";
import mainCategoryReducer from './slices/mainCategorySlice';
import subCategoryReducer from './slices/subCategorySlice';
import orderReducer from './slices/orderSlice';
import reviewsReducer from './slices/reviewsSlice';
import aboutUsReducer from './slices/aboutUsSlice';
import servicesReducer from "./slices/settings/servicesSlice";
import statisticsReducer from './slices/settings/statisticsSlice';
import websiteSettingsReducer from './slices/settings/WebsiteSettingsSlice'
import successMessageReducer from './slices/successMessageSlice';
import socialLinksReducer from './slices/socialLinksSlice';
import aboutUsFeatureReducer from './slices/aboutUsFeatureSlice';
import SliderReducer from './slices/settings/SliderSlice';
import galleryReducer from './slices/gallerySlice';
import otpReducer from './slices/otpSlice';
import resendEmailVerificationReducer from './slices/resendEmailVerification';
import unitReducer from './slices/myAccount/unitSlice';
import unitRequestReducer from './slices/myAccount/unitRequestSlice';
import equipmentsReducer from './slices/myAccount/equipmentsSlice';
import orderTableReducer from "./slices/myAccount/orderTableSlice";
import rateOrderReducer from "./slices/myAccount/rateOrder";
import customerDataReducer from './slices/myAccount/customerDataSlice';
import attachmentReducer from './slices/myAccount/attachmentSlice';
import orderDetailsReducer from './slices/myAccount/orderDetailsSlice';
import contractsReducer from './slices/myAccount/contractsSlice';
import changePasswordReducer from './slices/myAccount/changePasswordSlice';
import addressReducer from './slices/addressSlice';
import phoneNumberReducer from './slices/phoneNumberSlice';
import customerValidateSlice from './slices/ValidateCustomerMainData';
import contractDetailsSlice from './slices/myAccount/contractDetailsSlice';
import notificationsReducer from './slices/myAccount/notificationsSlice';
const store = configureStore({
  reducer: {
    lookup: lookupReducer,
    customer: customerReducer,
    login: loginReducer,
    successMessage: successMessageReducer,
    forgetPassword: forgetPasswordReducer,
    priceOffer: priceOfferReducer,
    mainCategory: mainCategoryReducer,
    subCategory: subCategoryReducer,
    notificationTypes: notificationTypeReducer,
    order: orderReducer,
    reviews: reviewsReducer,
    aboutUs: aboutUsReducer,
    services: servicesReducer,
    statistics: statisticsReducer,
    websiteSettings: websiteSettingsReducer,
    socialLinks: socialLinksReducer,
    aboutUsFeature: aboutUsFeatureReducer,
    sliders: SliderReducer,
    gallery: galleryReducer,
    otp: otpReducer,
    resendEmail: resendEmailVerificationReducer,
    unit: unitReducer,
    unitRequest: unitRequestReducer,
    equipments: equipmentsReducer,
    orders: orderTableReducer,
    rateOrder: rateOrderReducer,
    customerData: customerDataReducer,
    attachments: attachmentReducer,
    orderDetails: orderDetailsReducer,
    contracts: contractsReducer,
    changePassword: changePasswordReducer,
    address: addressReducer,
    phoneNumber: phoneNumberReducer,
    customerValidate: customerValidateSlice,
    contractDetails: contractDetailsSlice,
    notifications: notificationsReducer
  },
});

export default store;
